/**
 * A render target that takes a pass's output as the drawing buffer does: three tonemaps and encodes
 * into a target only when it is flagged `isXRRenderTarget`, and then takes the output space from
 * `texture.colorSpace` (`WebGLPrograms.js`).
 */
/** Not declared by @types/three: three sets the flag on plain render targets the same way (`XRManager.js`). */
export function takeOutputLikeDrawingBuffer(target) {
    target.isXRRenderTarget = true;
}
//# sourceMappingURL=outputTarget.js.map